<template>
    <div class="bg-white rounded-lg shadow flex-shrink-0">
        <div class="flex items-center space-x-2 px-4 py-2">
            <label class="text-sm font-medium text-gray-700">기준일자:</label>
            <input type="date" :value="modelValue" @change="handleDateChange"
                class="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm" />
            <button @click="selectToday"
                class="px-3 py-2 text-xs bg-blue-100 text-blue-600 rounded-lg hover:bg-blue-200 transition-colors">
                오늘
            </button>
        </div>
    </div>
</template>

<script>
import { getKoreanDateString } from '@/utils/dateUtil';

export default {
    name: 'SettingDateSelector',
    props: {
        modelValue: {
            type: String,
            required: true,
        },
    },
    emits: ['update:modelValue', 'dateSelected'],
    setup(props, { emit }) {
        const handleDateChange = (event) => {
            const selectedDate = event.target.value;
            emit('update:modelValue', selectedDate);
            emit('dateSelected', selectedDate);
        };

        const selectToday = () => {
            const today = getKoreanDateString();
            emit('update:modelValue', today);
            emit('dateSelected', today);
        };

        return {
            handleDateChange,
            selectToday,
        };
    },
};
</script>